import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Box } from '../../../layouts';
import { ABUtils } from '../../../utils';

const style = {
    borderRadius: 0,
    overflowX: 'scroll',
    flexBasis: '100%',
};

export const FragmentBody = ({ children, padding }) => {
    const { isCssVariationMobile } = ABUtils.getABs();
    const classNames = classnames({
        'odf-box': !isCssVariationMobile,
        'odf-space-inner-m': padding && !isCssVariationMobile,
        'odf-space-inner-top-m odf-space-inner-bottom-m': padding && isCssVariationMobile,
    });

    return (
        <Box className={classNames} {...style}>
            {children}
        </Box>
    );
};

FragmentBody.propTypes = {
    children: PropTypes.node.isRequired,
    padding: PropTypes.bool,
};

FragmentBody.defaultProps = {
    padding: true,
};
